import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SoftwareManagerRestService} from '../../../system/configuration/configuration-api/software-manager-rest.service';
import {GeneralService, PromiseService} from 'ac-infra';
import {RestResponseSuccess} from '../../server-actions/rest';

@Component({
    selector: 'file-selection',
    templateUrl: './file-selection.component.html',
    styleUrls: ['./file-selection.component.less']
})
export class FileSelectionComponent {

    @Input() fileObject: any;
    @Input() filePropertyName = 'logoId';
    @Output() fileIdChanged: EventEmitter<string> = new EventEmitter<string>();
    @Output() fileWasPicked: EventEmitter<string> = new EventEmitter<string>();
    @Output() fileWasUploaded: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() allowUpload = true;
    @Input() allowEmpty = true;
    @Input() showFileSelection = true;
    @Input() showImage = true;
    @Input() showText = false;
    @Input() readOnly = false;
    @Input() ngDisabled = false;
    @Input() label = '';
    @Input() showList = true;
    @Input() allFilesAllowed = false;
    @Input() fileTypes;
    @Input() fileType;
    @Input() getAdditionalSystemFiles = true;


    defaultFileTypes = ['png','jpeg', 'jpg'];


    fileIsReady = false;
    filePath: any;
    fileContent: any;
    statusColorsList = GeneralService.statusColors;

    noFile = {name: 'None', id: -1};

    constructor(private softwareManagerRestService: SoftwareManagerRestService) {}

    _tenantId: number;
    @Input() set tenantId(tenantId: number) {
        this._tenantId = tenantId < 0 ? -1 : tenantId;

        this.showFileSelection ? this.getFiles(this._tenantId) : this.readImage();
    }

    ngOnInit(){
        if(this.allFilesAllowed){
            this.fileTypes = undefined;
        }else{
            this.fileTypes = this.fileTypes || this.defaultFileTypes;
        }
    }

    onFileChange = (files) => {
        const file: any = {};
        file.content = files[0];
        file.data = {name: files[0].name, tenantId: this._tenantId || -1};

        if(this.fileType){
            file.data.fileType = this.fileType;
        }
        const onSuccess = (response: RestResponseSuccess) => {
            file.data.id = response.data.id;
            this.fileObject.files.push(file.data);
            this.fileObject[this.filePropertyName] = response.data.id;
            this.fileIdChanged.emit(this.fileObject[this.filePropertyName]);
            this.updateFileList();

        };
        const onFailure = () => {
            this.filePath = undefined;
            this.fileObject[this.filePropertyName] = -1;
            this.fileIdChanged.emit(this.fileObject[this.filePropertyName]);
        };

        this.softwareManagerRestService.addFile(file.data, file.content, undefined, onSuccess, onFailure);
    };

    readImage = () => {
        const onSuccess = (response: RestResponseSuccess) => {
            if(this.showText){
                this.convertBlobToText(response.data).then((text) => {
                    this.fileContent = text;
                    this.fileWasUploaded.emit(true);
                    this.fileIsReady = true;
                })
            }

            if(this.showImage){
                this.filePath = response.data;
                this.fileWasUploaded.emit(true);
                this.fileIsReady = true;
            }
        };

        const onFailure = () => {
            this.fileWasUploaded.emit(false);
            this.fileIsReady = true;
        };

        if (!this.fileObject[this.filePropertyName] || this.fileObject[this.filePropertyName] === -1) {
            this.filePath = undefined;
            this.fileIsReady = true;
        } else {
            this.softwareManagerRestService.getFileContent(onSuccess, onFailure, this.fileObject[this.filePropertyName], !this.showText);
        }
    };

    getFiles = (tenantId) => {
        const softwareManagerFilter: any = {filter: {}};

        if(this.getAdditionalSystemFiles){
            softwareManagerFilter.filter.tenantId = [-1];
        }

        if(this.fileType){
            softwareManagerFilter.filter.fileType = {values: [this.fileType], operators: ['=']};
        }

        if(tenantId && tenantId > 0){
            softwareManagerFilter.filter.tenantId = softwareManagerFilter.filter.tenantId || [];
            softwareManagerFilter.filter.tenantId.push(tenantId);
        }

        const success = (response: RestResponseSuccess) => {
            this.fileObject.files = response.data.files;
            if(this.allowEmpty){
                this.fileObject.files.unshift(this.noFile);
            }
            this.updateFileList();
        }

        this.softwareManagerRestService.getFiles({success, parameters: softwareManagerFilter});
    };

    updateFileList = () =>{
        this.fileObject.files = [...this.fileObject.files];
        this.readImage();
    };

    convertBlobToText(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => resolve(reader.result as string);
            reader.onerror = () => {
                this.fileWasUploaded.emit(false);
                reject(reader.error);
            }

            reader.readAsText(blob);
        });
    }

}



